import { createGlobalStyle } from 'styled-components';

export const AntSpinnerStyles = createGlobalStyle`
 .ant-spin-text, .ant-spin  {
    color: ${(props) => props.theme.colors.purpleNavi.plus2}
  }
  
`;
